/* eslint-disable react/display-name */
import {
  DateTimePicker,
  DateTimePickerToolbar,
} from '@mui/x-date-pickers/DateTimePicker';
import { MultiSectionDigitalClock } from '@mui/x-date-pickers/MultiSectionDigitalClock';
import PropTypes from 'prop-types';
import { memo } from 'react';

import dayjs from 'utils/dayjs';
import getDefaultTimezone from 'utils/timezone/getDefaultTimezone';

const DateTimePickerField = ({
  disabled,
  fieldErrorProps = {},
  inputProps = {},
  label,
  value,
  onChange,
}) => {
  return (
    <DateTimePicker
      disabled={disabled}
      timezone={getDefaultTimezone()}
      desktopModeMediaQuery="@media (max-width: 0px)"
      slotProps={{
        textField: {
          fullWidth: true,
          required: true,
          ...fieldErrorProps,
          inputProps,
        },
      }}
      components={{
        Toolbar: (props) => (
          <DateTimePickerToolbar
            {...props}
            value={value ? dayjs.tz(value, getDefaultTimezone()) : null}
          />
        ),
      }}
      label={label}
      value={value}
      views={['month', 'year', 'day', 'hours', 'minutes']}
      viewRenderers={{
        hours: (props) => (
          <MultiSectionDigitalClock
            timezone={props.timezone}
            value={props.value}
            onChange={props.onChange}
            sx={{
              width: '320px',
              '& .MuiList-root': {
                flex: 1,
                display: 'flex',
                flexDirection: 'column',
              },
              '& .MuiMenuItem-root': { width: 'auto' },
            }}
          />
        ),
        minutes: (props) => (
          <MultiSectionDigitalClock
            timezone={props.timezone}
            value={props.value}
            onChange={props.onChange}
            sx={{
              width: '320px',
              '& .MuiList-root': {
                flex: 1,
                display: 'flex',
                flexDirection: 'column',
              },
              '& .MuiMenuItem-root': { width: 'auto' },
            }}
          />
        ),
      }}
      openTo="day"
      onChange={onChange}
    />
  );
};

DateTimePickerField.propTypes = {
  disabled: PropTypes.bool,
  fieldErrorProps: PropTypes.object,
  inputProps: PropTypes.object,
  label: PropTypes.string,
  value: PropTypes.instanceOf(dayjs),
  onChange: PropTypes.func,
};

export default memo(DateTimePickerField);
